import { useContext } from 'react';
import { styled } from 'styled-components';

import { ConfigurationContext } from '../../../context/configurationContext';
import { ReactComponent as ArrowLeftSvg } from '../../../assets/arrow-left-light.svg';
import pcma_logo from '../../../assets/pcma_logo.png';
import AdditionalMenu from './additionalMenu';

interface Props {
  onClose?: () => void;
}

const DEFAULT_CARE_TEAM_NAME = 'Your Care Team';

const ChatHeader: React.FC<Props> = ({ onClose }) => {
  const configurationContext = useContext(ConfigurationContext);

  return (
    <Header>
      <CareTeam>
        {onClose && (
          <BackButton type="button" onClick={() => onClose()}>
            <ArrowLeftSvg />
          </BackButton>
        )}
        <CareTeamLogo
          src={configurationContext?.iconConversationUrl ?? pcma_logo}
          alt={configurationContext?.careTeamName ?? DEFAULT_CARE_TEAM_NAME}
          onClick={() => onClose?.()}
        />
        <CareTeamContainer>
          <CareTeamName>
            {configurationContext?.careTeamName ?? DEFAULT_CARE_TEAM_NAME}
          </CareTeamName>
        </CareTeamContainer>
      </CareTeam>
      <CareTeam>
        {configurationContext?.authenticated && onClose ? (
          <AdditionalMenu onClose={onClose} />
        ) : null}
      </CareTeam>
    </Header>
  );
};

const Header = styled.header`
  background-color: var(--background-color);
  border-bottom: 1px solid var(--border-color);
  z-index: 200000;
  height: 80px;
  position: relative;
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
  justify-content: space-between;
`;

const CareTeamLogo = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  cursor: pointer;
`;

const CareTeam = styled.div`
  display: flex;
`;

const CareTeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: center;
`;

const CareTeamName = styled.h1`
  font-size: 16px;
  margin-bottom: 0;
  font-weight: bold;
  color: var(--font-color);
`;

const BackButton = styled.button`
  border: none;
  background-color: transparent;
  margin-right: 16px;
  padding-bottom: 2px;

  svg {
    overflow: visible;

    path {
      stroke: var(--action-color);
    }
  }

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 680px) {
    padding-left: 0;
    padding-right: 0;
    margin-right: 8px;
    margin-left: -4px;
  }
`;

export default ChatHeader;
